import React, {FunctionComponentElement, useEffect} from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const ComponentToShow = (props: {component: React.FC, props: { [key: string]: any }}): FunctionComponentElement<{}> => {
  return React.createElement(props.component, props.props);
};

export const I18nWrapper = (props: {component: React.FC, props: { [key: string]: any }}): JSX.Element => {
  const languageHasChanged = () => !localStorage.getItem('roedl-language').includes(i18n.language);
  const changeLanguageHandler = () => {
    i18n.changeLanguage(localStorage.getItem('roedl-language').includes('en') ? 'en' : 'de');
  };

  if (languageHasChanged())
    changeLanguageHandler();

  useEffect(() => {
    const storageChangeHandler = () => {
      if (languageHasChanged())
        changeLanguageHandler();
    };

    window.addEventListener('storage', storageChangeHandler);

    return () => {
      window.removeEventListener('storage', storageChangeHandler);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ComponentToShow component={props.component} props={props.props} />
    </I18nextProvider>
  );
};
